import React, { useEffect, useState } from "react";
import { User, ShoppingCart, MessageSquare, HelpCircle, Search, MessageCircle } from "lucide-react";

export default function Header() {
  const [showHelpPopup, setShowHelpPopup] = useState(false);

  // Show popup when scrolling
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 150) {
        setShowHelpPopup(true);
      } else {
        setShowHelpPopup(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <header className="fixed top-0 left-0 w-full z-50 bg-black/80 backdrop-blur-lg border-b border-white/10 shadow-lg">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#00ffcc] to-[#ff007a] flex items-center justify-center shadow-lg">
              <span className="font-black text-black text-lg">1</span>
            </div>
            <div>
              <div className="text-xl font-extrabold text-white tracking-wide">ShopAt1Stop</div>
              <div className="text-xs text-gray-400 -mt-1">One stop, every vibe</div>
            </div>
          </div>

          {/* Search Bar */}
          <div className="flex-1 mx-6">
            <div className="relative w-full max-w-md">
              <input
                type="text"
                placeholder="Search products..."
                className="w-full py-2 pl-10 pr-4 rounded-full bg-black/40 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#00ffcc] focus:ring-offset-1 focus:ring-offset-black shadow-md"
              />
              <Search
                size={18}
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#00ffcc]"
              />
            </div>
          </div>

          {/* Action icons */}
          <div className="flex items-center gap-4">
            {/* <button
              title="Chat AI"
              className="flex items-center gap-2 px-3 py-2 rounded-full bg-white/10 hover:bg-white/20 transition"
            >
              <MessageSquare size={18} />
              <span className="hidden md:block text-sm">Chat AI</span>
            </button> */}

            <button
              title="Help Us"
              className="flex items-center gap-2 px-3 py-2 rounded-full bg-white/10 hover:bg-white/20 transition"
            >
              <HelpCircle size={18} />
              <span className="hidden md:block text-sm">Help Us</span>
            </button>

            <button title="Sign in" className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition">
              <User size={18} />
            </button>

            <button title="Cart" className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition">
              <ShoppingCart size={18} />
            </button>
          </div>
        </div>
      </header>

      {/* Floating Chat AI Icon (Bottom Right) */}
      <div className="fixed bottom-5 right-5 z-50">
        <button className="bg-[#00ffcc] text-black p-4 rounded-full shadow-xl hover:bg-[#00e6b8] transition">
          <MessageCircle size={30} />
        </button>
      </div>

      {/* Popup Text on Scroll */}
      {showHelpPopup && (
        <div className="fixed bottom-24 right-6 bg-white border shadow-xl px-4 py-2 rounded-xl text-gray-900 text-sm z-50 animate-popup">
          👋 Hi! Need any help?
        </div>
      )}

      <style>
        {`
          @keyframes popup {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-popup {
            animation: popup 0.3s ease-out;
          }
        `}
      </style>
    </>
  );
}
